import { Button, Form, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import './ForgetPasswordForm.scss';

interface ForgetPasswordFormProps {
    loading: boolean,
    open?: boolean,
    onSendForm: (usernameOrEmail: string) => void,
    onCancel: () => void
}

const ForgetPasswordFormComponent = (props: ForgetPasswordFormProps) : JSX.Element => {
    const { t } = useTranslation();
    
    const [form] = useForm();

    const { loading, open, onSendForm, onCancel } = props;

    useEffect(() => {
        if (open === false) {
            form.resetFields();
        }
    }, [open]);

    const onFinish = () => {
        onSendForm(form.getFieldValue("email"));
    }

    const onCancelPush = () : void => {
        form.resetFields();
        onCancel();
    }

    return(
        <div className="forget-password-form">
            <Form form={form} onFinish={onFinish} layout="horizontal">
                <Form.Item
                    label={t("components.forget-password-form.email")}
                    name="email"
                    rules={[{ required: true, message: t("forms.validations.required-field")! }]}
                >
                    <Input className="app-input" type="email"/>
                </Form.Item>
                <div className="actions">
                    <Button className="app-button reverse" type="default" key="back" onClick={onCancelPush}>
                        {t("components.forget-password-form.cancel")}
                    </Button>
                    <Button disabled={loading} className="app-button" key="submit" htmlType="submit" type="primary" loading={loading}>
                        {t("components.forget-password-form.submit")}
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default ForgetPasswordFormComponent;